// see https://stackoverflow.com/questions/49411796/how-do-i-detect-whether-i-am-on-server-on-client-in-next-js
export const isServer = typeof window === 'undefined';
